module.exports = __webpack_public_path__ + "static/media/licenta22.0d3e320b.png";